import { QueryClient } from '@tanstack/vue-query'
import { persistQueryClient } from '@tanstack/query-persist-client-core'
import { pipelinePersister, deleteLegacyPerReqCaches } from './persister'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 24 * 60 * 60 * 1000,
      refetchOnWindowFocus: true,
    },
  },
})

// VueQueryPlugin only installs isRestoring once the app mounts, and the cache
// starts restoring here, before that.
queryClient.isRestoring ??= ref(false)
const isRestoring = queryClient.isRestoring

isRestoring.value = true
const [, restored] = persistQueryClient({ queryClient, persister: pipelinePersister })
restored.then(() => { isRestoring.value = false })

deleteLegacyPerReqCaches().catch(() => {})
